//angular imports
import {
    ChangeDetectionStrategy,
    Component, 
    WritableSignal, 
    signal,
} from '@angular/core';

//local imports
import { PresenterType } from '@shared/components';
import { RoomUpdatedMessage } from './room-updated.message';

@PresenterType(
{
    model: RoomUpdatedMessage
})
@Component({
    selector: 'room-updated-message-template',
    templateUrl: './room-updated-message-template.component.html',
    changeDetection: ChangeDetectionStrategy.OnPush,
    standalone: false
})
export class RoomUpdatedMessageTemplateComponent
{
    public data: WritableSignal<RoomUpdatedMessage>;
    
    constructor() {
        this.data = signal<RoomUpdatedMessage>(null);
    }
}